import { FC, ReactNode } from 'react';

interface Props {
  rotulo: string;
  testId?: string;
  children: ReactNode;
}

/**
 * Painel flutuante logo abaixo da barra de filtros (o ancestral `relative`), alinhado à
 * esquerda e nunca mais largo que ela: embaixo do botão, o calendário de dois meses ou a
 * lista de produtos passariam da borda da tela no celular. O pai controla o aberto e
 * fecha com `useFechaFora` — o painel continua dentro do elemento dele no DOM.
 */
const Popover: FC<Props> = ({ rotulo, testId, children }) => (
  <div
    role="dialog"
    aria-label={rotulo}
    data-testid={testId}
    className="absolute left-0 top-full z-30 mt-2 max-w-full rounded-xl border border-theme-border bg-surface-card p-3 shadow-xl"
  >
    {children}
  </div>
);

export default Popover;
